import { render, staticRenderFns } from "./IconGenderMale.vue?vue&type=template&id=4295ff7c&"
import script from "./IconGenderMale.vue?vue&type=script&lang=ts&"
export * from "./IconGenderMale.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports